<template>
  <li class="py-10 border-line border-b last-of-type:border-none max-w-256.25 mx-auto">
    <div class="flex items-center gap-5 mb-5 text-sm">
      <p class="bg-(--accent-color) rounded-lg px-4 py-1.5">{{ resource.type }}</p>
      <p class="text-grey-mid">{{ resource.year }}</p>
    </div>
    <div class="md:flex md:gap-12 md:items-start">
      <div>
        <h2 class="font-semibold mb-4 md:mb-5 text-xl">{{ resource.title }}</h2>
        <p>{{ resource.description }}</p>
      </div>
      <a v-if="attachment" :href="attachment"
         target="_blank" :title="resource.title" class="block button button-secondary mt-8 md:mt-0 md:ml-auto">
        {{ $t('view') }}
      </a>
    </div>
  </li>
</template>

<script lang="ts">
import type {PropType} from "vue";

export default {
  name: 'PostCard',
  props: {
    resource: {
      type: Object as PropType<Document | Post>,
      required: true
    }
  },
  computed: {
    attachment() {
      if (this.resource.url) return this.resource.url
      if(this.resource.file) return this.resource.file.original
      return null
    }
  }
}
</script>